<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item">
        <a class=" text-decoration-none" routerLink="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>
      <li class="breadcrumb-item active text-secondary" aria-current="page">
        2.07.2019
      </li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <h3 class="mb-0 text-primary">Aarauer Nachrichten – Keine Prostitution, sondern eine Partnerschaft auf Zeit</h3>
      <div class="mb-1 text-body-secondary">2.07.2019</div>
      <p>
        Das Zustandekommen dieses
        <a href="/../../../content/docs/Aarauer-Nachrichten.pdf" target="_blank">
          Artikels in den Aarauer Nachrichten
        </a>
        hat mich besonders gefreut😊! Es ist alles andere als
        selbstverständlich, dass sich Klient, Bezugsperson wie auch institutionelle Einrichtung überhaupt und insbesondere mit
        so viel Offenheit zur Thematik äussern!
    </div>

    <div class="col-auto h d-lg-block">
      <img src="/../../../content/blog/blog10_1.jpg" alt="sexcare bild" width="250">
    </div>
  </div>
</div>
